module.exports = __webpack_public_path__ + "img/hero.68743ad5.png";